module.exports = __webpack_public_path__ + "img/ggg.64a900d9.png";